/*
 *
 * PciEmailDocumentsModal index
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

export { default } from './PciEmailDocumentsModalContainer'
